import { withStyles } from "@mui/styles"
import { useEffect, useState } from "react"
import Dropzone from "react-dropzone"
import { FormattedMessage, injectIntl } from "react-intl"
import { Styles } from "src/styles/material-styles"
import AttachFileIcon from '@mui/icons-material/AttachFile';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import { Button, Grid, IconButton, Pagination, Tooltip, Typography } from "@mui/material"
import Api from "src/services/api"
import FileCard from "./filecard"
import FileCardSkeleton from "./filecardskeleton"
import * as LLMDocumentService from 'src/services/llmdocument.service';
import DialogGeneral from "src/components/dialog-general";
import LLMDocumentDetailDialog from "src/components/details-dialogs/llm-document-detail-dialog";
import { Refresh, WifiOff } from "@mui/icons-material"
import * as LLMService from "src/services/llm.service.js";
import FirstElement from "src/components/first-element"
import SmartToyIcon from '@mui/icons-material/SmartToy';

const LlmDocuments = (props) => {
    const { classes, intl, llm, onShowNotification, onLoading, hirerid, loading } = props

    const [files, setFiles] = useState([])
    const [itens, setItens] = useState([])
    const [open, setOpen] = useState(false)
    const [fileSelected, setFileSelected] = useState(null)
    const [detailItem, setdetailItem] = useState(null)
    const [llmErrorInfo, setLllmErrorInfo] = useState({ opensearchconnectionon: true, opensearchconnectionerrormessage: '' })
    const [page, setPage] = useState(1)
    const [totalLlmDocument, setTotalLlmDocument] = useState(0)
    const [totalPages, setTotalPages] = useState(0)
    const [pageStart, setPageStart] = useState(0)
    const [pageEnd, setPageEnd] = useState(10)

    const openLLMDocumentDetail = (document) => {
        console.log('openLLMDocumentDetail called with document:', document)
        setdetailItem({
            id: document.id,
            type: 'llmdocument',
            bucketkey: document.bucketkey,
            llmId: document.llmId,
            title: document.filename || '',
            displayTitle: document.filename || '',
            createdat: document.createdat || '',
            processingerror: document.processingerror || '',
            hirerid: document.hirerid || '',
        })
    }

    const closeLLMDocumentDetail = () => setdetailItem(null)

    useEffect(() => {
        refresh()
    }, [])

    const refresh = async () => {
        onLoading(true)
        await getItems()
        await getLLMErrorInfo()
        onLoading(false)
    }

    const removeFile = (file) => {
        let array = [...files]
        let index = array.indexOf(file)
        if (index !== -1) {
            array.splice(index, 1)
            setFiles(array)
        }
    }

    const removeItem = (file) => {
        setItens(itens.filter(item => item.id !== file.id))
    }

    const getItems = async (page = 1) => {
        await Api.get(`/llmdocument/list/${llm.id}?page=${page}`,)
            .then((response) => {
                if (response) {
                    setItens(response.data?.data)
                    setTotalLlmDocument(response.data?.count)
                    setPagination(response.data?.count, page)
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.getting.files" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
    }

    const getLLMErrorInfo = async () => {
        onLoading(true)

        try {
            const response = await LLMService.getErrorInfoById(llm.id)

            if (response && response.success && response.data) {
                setLllmErrorInfo(response.data)
            } else {
                let message = "Não foi possível obter os dados de conexão da llm"
                onShowNotification(message, 'error')
            }
        } catch (err) {
            let message = "Não foi possível obter os dados de conexão da llm"
            onShowNotification(message, 'error')
        }
    }

    const addFiles = async () => {

        if (files.length === 0) {
            onShowNotification(intl.formatMessage({ id: "attach.your.files" }), 'warning')
            return
        }

        onLoading(true)
        const apiurl = Api.apiurlbase().replace("https", '').replace("http", '').replace("://", "").replace('/', '')
        let data = new FormData()
        data.append('hirerid', hirerid)
        data.append('llmId', llm.id)
        data.append('urlapi', apiurl)
        files.forEach((file, index) => {
            data.append('files', file)
        })

        await Api.post(`/llmdocument/upload`, data)
            .then((response) => {
                onShowNotification(intl.formatMessage({ id: "add.success" }), 'success')
                setFiles([])
                if (response)
                    setItens([...response.data?.data, ...itens])
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.uploading.files" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        onLoading(false)
    }

    const getFile = async (file) => {
        onLoading(true)

        let url = await LLMDocumentService.getFileByBucketKey(hirerid, file.bucketkey)
        if (url && url.data && url.data.data && url.data.success) {
            onLoading(false)
            window.open(`${url.data.data}`, '_blank')
        } else {
            onLoading(false)
            onShowNotification(intl.formatMessage({ id: "file.not.found" }), 'error')
        }
    }

    const onDelete = async () => {
        onLoading(true)

        await Api.delete(`/llmdocument/${fileSelected.id}`)
            .then((response) => {
                onShowNotification(intl.formatMessage({ id: "delete.sucess" }), 'success')
                if (response) {
                    setItens(prevFiles =>
                        prevFiles.map(file =>
                            file.id === fileSelected.id
                                ? { ...file, status: 7 }
                                : file
                        )
                    )
                }
            }).catch((error) => {
                let message = intl.formatMessage({ id: "error.deleting.files" })
                if (error.response && error.response.data && error.response.data.errors && error.response.data.errors.length > 0) {
                    message = error.response.data.errors[0]
                }
                else {
                    message = intl.formatMessage({ id: "process.error" })
                }
                onShowNotification(message, 'error')
            })
        setFileSelected(null)
        setOpen(false)
        onLoading(false)
    }

    const setPagination = (count, page) => {
        setTotalPages(Math.ceil(count / 10))
        const start = count > 0 ? (page - 1) * 10 + 1 : 0
        setPageStart(start)
        setPageEnd(Math.min(start + 9, count))
    }

    const onChangePaginate = async (event, value) => {
        setPage(value)
        onLoading(true)
        await getItems(value)
        await getLLMErrorInfo()
        onLoading(false)
    }

    return (
        <div>
            <Grid container justifyContent={'flex-start'} direction={'row'} alignItems={'center'} paddingTop={2}>
                <Grid item container direction={'row'} xs={11} justifyContent={'flex-start'}>
                    {!llmErrorInfo.opensearchconnectionon && (
                        <Grid item xs={1} paddingLeft={2}>
                            <WifiOff
                                sx={{
                                    '&&': {
                                        color: '#f44336 !important',
                                    },
                                }}
                            />
                        </Grid>
                    )}
                    {!llmErrorInfo.opensearchconnectionon &&
                        llmErrorInfo.opensearchconnectionerrormessage && (
                            <Grid item xs={11}>
                                <Tooltip
                                    title={llmErrorInfo.opensearchconnectionerrormessage}
                                    arrow
                                >
                                    <Typography
                                        className={classes.value}
                                        variant="body2"
                                    >
                                        {intl.formatMessage({
                                            id: "opensearch.connection.error",
                                        })}
                                    </Typography>
                                </Tooltip>
                            </Grid>
                        )}
                </Grid>
                <Grid item xs={1}>
                    <IconButton className={classes.attachmentIcon} color="primary" onClick={refresh}>
                        <Refresh />
                    </IconButton>
                </Grid>
            </Grid>
            <section style={{ width: '100%', marginTop: '10px', marginBottom: '10px' }}>
                <div className={classes.dropzoneArea} style={{ minHeight: '70px', marginTop: '5px ' }}>
                    <Dropzone onDrop={acceptedFiles => {
                        setFiles([...acceptedFiles, ...files])
                    }}>
                        {({ getRootProps, getInputProps, acceptedFiles }) => (
                            <div {...getRootProps()}>
                                <input {...getInputProps()} />
                                <AttachFileIcon />
                                <Typography component="span" fontWeight="bold" fontSize={16} color="gray">
                                    <FormattedMessage id="drag.and.drop.files" />
                                </Typography>
                            </div>
                        )}
                    </Dropzone>
                    {files.map(file => {
                        return (
                            <div className={classes.dropzoneItem} key={file.name}>
                                {file.name}
                                <DeleteForeverIcon className={classes.deleteItem} onClick={() => { removeFile(file) }} />
                            </div>
                        )
                    })}
                </div>
            </section>
            <Grid container justify="flex-end" style={{ justifyContent: 'flex-end' }}>
                <Grid item xs={12} sm={4} md={2} justify="flex-end" >
                    <Button
                        fullWidth
                        variant='contained'
                        color='primary'
                        className={classes.submit}
                        onClick={addFiles}
                    >
                        <FormattedMessage id="save" />
                    </Button>
                </Grid>
            </Grid>
            <Grid item xs={12} style={{ marginTop: '20px' }}>
                <Grid container spacing={2} direction='row' >
                    <Grid container spacing={2} direction="row" justifyContent="center" >
                        {loading
                            ? Array.from({ length: 9 }).map((_, index) => (
                                <FileCardSkeleton key={index} />
                            ))
                            :
                            totalLlmDocument > 0 ?
                                itens?.map((item, index) => (
                                    <FileCard
                                        key={index}
                                        file={item}
                                        onOpenFile={() => openLLMDocumentDetail(item)}
                                        onDelete={() => {
                                            setFileSelected(item);
                                            setOpen(true);
                                        }}
                                        intl={intl}
                                    />
                                )) :
                                <FirstElement
                                    small
                                    title={intl.formatMessage({ id: "llm.document.create.first.llm.document" })}
                                    icon={<SmartToyIcon style={{ fontSize: "45px" }} />}
                                />
                        }
                    </Grid>
                </Grid>
            </Grid>

            {totalLlmDocument > 0 && <Grid container style={{ marginBottom: 12, marginTop: 8 }}>
                <Grid item xs={12} md={3}>
                    <Pagination count={totalPages} page={page} onChange={onChangePaginate} />
                </Grid>
                <Grid item xs={12} sm={3} style={{ marginTop: 6 }}>
                    {pageStart} {<FormattedMessage id="to" />} {pageEnd} {<FormattedMessage id="of" />} {totalLlmDocument} {<FormattedMessage id="register" />}
                </Grid>
            </Grid>}

            <LLMDocumentDetailDialog
                open={!!detailItem}
                onClose={closeLLMDocumentDetail}
                item={detailItem}
                intl={intl}
                setMessage={(isOpen, variant, message) => {
                    if (isOpen) {
                        onShowNotification(message, variant)
                    }
                }}
            />

            <DialogGeneral
                intl={intl}
                dialogTitle={fileSelected?.id + " - " + fileSelected?.filename}
                dialogSubTitle="Você realmente deseja remover este arquivo da llm?"
                open={open}
                openOrCloseModalFunction={setOpen}
                handleConfirmation={onDelete}
            />
        </div>
    )
}

export default injectIntl(withStyles(Styles)(LlmDocuments))